// @flow

const getGa = (): * => (typeof window !== 'undefined' && window.ga ? window.ga : null);

const getTracker = (): * => {
  const ga = getGa();
  if (ga) {
    return ga.hasOwnProperty('getAll') ? ga.getAll()[0] : null;
  }
  return null;
};

const getClientID = (): * => {
  const tracker = getTracker();
  return tracker ? tracker.get('clientId') : null;
};

export { getGa, getTracker, getClientID };
